export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kwota"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wynik"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transakcja"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odśwież status"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przydatne linki"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W toku"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sukces"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nieudany"])}
}